import { HttpErrorResponse } from '@angular/common/http'
import { MonoTypeOperatorFunction, throwError, timer } from 'rxjs'
import { retry } from 'rxjs/operators'

/**
 * Re-subscribe (i.e. re-send the request) when the API answers 503.
 *
 * A 503 means a dependency behind the API (the object store, for uploads) is
 * briefly overloaded; the request itself was fine and nothing was saved, so
 * sending it again is safe and usually succeeds. Any other failure — including
 * a 429, which the rate-limit interceptor already owns — propagates untouched.
 *
 * Exponential backoff with jitter so several tabs/uploads don't retry in step.
 * Only use this on requests that are safe to repeat.
 */
export function retryOnServiceUnavailable<T>(count = 2, baseDelayMs = 1500): MonoTypeOperatorFunction<T> {
  return retry({
    count,
    delay: (error, attempt) => {
      if (!(error instanceof HttpErrorResponse) || error.status !== 503) {
        return throwError(() => error)
      }
      const backoff = baseDelayMs * 2 ** (attempt - 1)
      return timer(backoff + backoff * 0.2 * Math.random())
    },
  })
}
